import React, {Component} from 'react';
import {Input} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import './timePickerField.scss';

class TimePickerField extends Component {
  render() {
    const {timeFormat, timeFormatOrigin, 'input': {onBlur, ...input}, ...custom} = this.props;
    return (
      <div>
        <DatePicker
          locale='es'
          customInput={<Input icon='time' size='small' />}
          showTimeSelect
          showTimeSelectOnly
          timeCaption='Tiempo'
          timeFormat={timeFormat}
          {...input}
          {...custom}
          value={input.value ? moment(input.value, timeFormatOrigin).format(timeFormat) : null}
          selected={input.value ? moment(input.value, timeFormatOrigin) : null}
        />
      </div>
    );
  }
}

export default TimePickerField;
